"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._clearAllRegisteredCookies_FOR_TESTS_ONLY_DONT_USE_THIS = void 0;
var _getCookieLevel = _interopRequireDefault(require("./getCookieLevel"));
var _expireUnauthorizedCookies = _interopRequireDefault(require("./expireUnauthorizedCookies"));
var _getCookiePreference = _interopRequireDefault(require("./getCookiePreference"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var globalCookies = require('../globalCookies.json');
var ADVERTISING_COOKIE = 2;
var PREFERENCE_COOKIE = 'notice_preferences';
var SAFE_COOKIES = _objectSpread({}, globalCookies);
function getCookie(name) {
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

// eslint-disable-next-line
var _clearAllRegisteredCookies_FOR_TESTS_ONLY_DONT_USE_THIS = exports._clearAllRegisteredCookies_FOR_TESTS_ONLY_DONT_USE_THIS = function _clearAllRegisteredCookies_FOR_TESTS_ONLY_DONT_USE_THIS() {
  SAFE_COOKIES = _objectSpread({}, globalCookies);
};

/**
 * @name safeCookies
 * @description prevent cookies not allowed by the user to be set in the browser.  If cookies are not listed, they will be assumed to be level 0.
 * @param {Object} [cookies = {}] key value pair of cookies to their corresponding consent level.
 *  <h6>Cookie Consent Level: </h6>
 *  <ul>
 *    <li>0: required</li>
 *    <li>1: functional</li>
 *    <li>2: advertising</li>
 * </ul>
 * @param {Object} [options = {}] options
 * @param {Boolean} options.showWarnings [options.showWarnings = false] show warnings for unlisted cookies
 *
 * @example
 *    import safeCookies from '@concur/safe-cookies';
 *
 *    safeCookies({
 *      "myRequiredCookie": 0,
 *      "myAdvertisingCookie":2
 *    })
 *
 *  *OR*
 *
 *   <script src="https://static.concursolutions.com/nui/safecookies/static/safe-cookies-20180509.js"></script>
 *   <script>
 *     window.SafeCookies({
 *      "myRequiredCookie": 0,
 *      "myAdvertisingCookie":2
 *    });
 *   </script>
 *
 *  @example
 *  app.get("/path", (req,res) => {
 *     //assuming user has consented to functional (i.e. level 1) cookies
 *    res.cookie("myRequiredCookie", "xxx"); //will set cookie
 *    res.cookie("myAdvertisingCookie", "yyy"); //won't set cookie
 *    res.cookie("myUnlistedCookie", "zzz"); // will warn, but set the cookie anyway
 *  })
 */
var _default = exports.default = function _default(cookies) {
  SAFE_COOKIES = _objectSpread(_objectSpread({}, cookies), SAFE_COOKIES);
  var cookieDesc;
  if (global.Document || global.HTMLDocument) {
    cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
  } else {
    var cookieSetter = document.__lookupSetter__('cookie');
    var cookieGetter = document.__lookupGetter__('cookie');
    cookieDesc = Object.create({
      get: cookieGetter,
      set: cookieSetter
    });
  }
  if (Object.prototype.hasOwnProperty.call(document, 'cookie') && Object.getOwnPropertyDescriptor(document, 'cookie').configurable === false) {
    // Idempotence check. Short circuit if a custom cookie property has
    // already been defined directly on the document instance.
    return;
  }
  Object.defineProperty(document, 'cookie', {
    get: function get() {
      return cookieDesc.get.call(document);
    },
    set: function set(value) {
      var cookiePref = (0, _getCookiePreference.default)(getCookie(PREFERENCE_COOKIE));
      var _value$split = value.split('='),
        _value$split2 = _slicedToArray(_value$split, 1),
        name = _value$split2[0];
      var isPreferenceCookie = name === PREFERENCE_COOKIE;
      var cookieLevel = (0, _getCookieLevel.default)(name, SAFE_COOKIES);
      var retVal;
      if (isPreferenceCookie || !cookieLevel || cookiePref < 0 || cookieLevel <= cookiePref) {
        /* eslint prefer-rest-params:0 */
        retVal = cookieDesc.set.apply(document, arguments);
      }
      if (isPreferenceCookie && (0, _getCookiePreference.default)(getCookie(PREFERENCE_COOKIE)) < ADVERTISING_COOKIE) {
        (0, _expireUnauthorizedCookies.default)();
      }
      // eslint-disable-next-line no-setter-return
      return retVal;
    },
    configurable: false
  });

  /* eslint no-extend-native: 0 */
  /* eslint no-bitwise: 0 */
  /* eslint no-plusplus: 0 */
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      },
      configurable: true,
      writable: true
    });
  }
};